import React from 'react';
import { Tabs } from 'antd';
import CharacterConfigurator from './CharacterConfigurator';
import SceneConfigurator from './SceneConfigurator';
import ObjectConfigurator from './ObjectConfigurator';
import TextConfigurator from './TextConfigurator';
import WinConditionConfigurator from './WinConditionConfigurator';
import SoundsConfigurator from './SoundsConfigurator';

import { TSprite } from '../../../models/objects/sprite';
import { TObstacle, TScene } from '../../../models/objects/objects';
import { SoundConfig, TextObjectConfig, WinCondition } from '../types/config';

interface ConfiguratorPanelProps {
    sprites: TSprite[];
    scenesConfig: TScene[];
    obstacles: TObstacle[];
    textsConfig: TextObjectConfig[];
    winConditions: WinCondition[];
    sounds: SoundConfig[];
}

// ✅ Composant scrollable réutilisable pour chaque onglet
const ScrollPane: React.FC<React.PropsWithChildren> = ({ children }) => (
    <div
        style={{
            padding: 16,
            overflow: 'auto',
            flex: 1,
            minHeight: 0,
        }}
    >
        {children}
    </div>
);

const ConfiguratorPanel: React.FC<ConfiguratorPanelProps> = ({
    scenesConfig,
    sprites,
    obstacles,
    textsConfig,
    winConditions,
}) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0, // important pour éviter les coupures dans le Drawer
                height: '100%',
            }}
        >
            <Tabs
                defaultActiveKey="1"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    minHeight: 0,
                }}
                items={[
                    {
                        key: '1',
                        label: 'Scène',
                        children: (
                            <ScrollPane>
                                <SceneConfigurator scenesConfig={scenesConfig} />
                            </ScrollPane>
                        ),
                    },
                    {
                        key: '2',
                        label: 'Personnages',
                        children: (
                            <ScrollPane>
                                <CharacterConfigurator sprites={sprites} />
                            </ScrollPane>
                        ),
                    },
                    {
                        key: '3',
                        label: 'Objets',
                        children: (
                            <ScrollPane>
                                <ObjectConfigurator obstacles={obstacles} />
                            </ScrollPane>
                        ),
                    },
                    {
                        key: '4',
                        label: 'Textes',
                        children: (
                            <ScrollPane>
                                <TextConfigurator textsConfig={textsConfig} />
                            </ScrollPane>
                        ),
                    },
                    {
                        key: '5',
                        label: 'Sons',
                        children: (
                            <ScrollPane>
                                <SoundsConfigurator />
                            </ScrollPane>
                        ),
                    },
                    {
                        key: '6',
                        label: 'Win Conditions',
                        children: (
                            <ScrollPane>
                                <WinConditionConfigurator winConditions={winConditions} />
                            </ScrollPane>
                        ),
                    },
                ]}
            />
        </div>
    );
};

export default ConfiguratorPanel;
